<template>
  <div>
    <!-- 左侧返回和首页 -->
    <div class="left-caozuoicon">
      <div @click="goBack">
        <i class="el-icon-back"></i>
      </div>
      <div @click="goHome">
        <i class="el-icon-s-home"></i>
      </div>
      <div class="pgeas-tab">
        <el-tag effect="dark" closable @close="goBack">
          <i :class="nowRouteIcon"></i>
          <span style="margin-left: 5px">{{ nowRouteName }}</span>
        </el-tag>
      </div>
    </div>
    <!-- 右侧用户登录图标 -->
    <div class="user-logininfo">
      <!-- 顶部搜索框 -->
      <HeaderSeach />
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link right-userName">
          <div class="image">
            <img src="../../assets/logo/userimg.jpeg" alt="" srcset="" />
          </div>
          <div>{{ userInfo.loginName }}</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="password" divided>
            <i class="el-icon-lock"></i>
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item command="points" divided>
            <i class="el-icon-coin"></i>
            <span>积分配置</span>
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </el-dropdown-item>        
        </el-dropdown-menu>
      </el-dropdown>

    <!-- 修改密码弹框 -->
    <el-dialog 
      title="修改密码" 
      :visible.sync="passwordDialogVisible" 
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form 
        :model="passwordForm" 
        :rules="passwordRules" 
        ref="passwordForm"
        label-width="100px"
      >
        <!-- <el-form-item label="原密码" prop="oldPassword">
          <el-input 
            v-model="passwordForm.oldPassword" 
            type="password" 
            placeholder="请输入原密码"
            show-password
          ></el-input>
        </el-form-item> -->
        
        <el-form-item label="新密码" prop="newPassword">
          <el-input 
            v-model="passwordForm.newPassword" 
            type="password" 
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input 
            v-model="passwordForm.confirmPassword" 
            type="password" 
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary"  @click="submitPasswordForm" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 积分配置弹框 -->
    <el-dialog 
      title="积分配置" 
      :visible.sync="pointsDialogVisible" 
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form 
        :model="pointsForm" 
        :rules="pointsRules" 
        ref="pointsForm"
        label-width="100px"
      >
        <el-form-item label="积分配置" prop="pointSetting">
          <el-input 
            v-model="pointsForm.pointSetting" 
            type="number" 
            placeholder="请输入积分兑换比例"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="tips">兑换比例：充一度电兑换的积分数量</div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="pointsDialogVisible = false">取 消</el-button>
        <el-button type="primary"  @click="submitPointsForm">确 定</el-button>
      </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import HeaderSeach from './HeaderSearch'
import { getChangePassword,updatePointSetting,getPointSetting } from '../../api/login'

export default {
  components: {
    HeaderSeach,
  },
  data() {
    // 验证确认密码是否与新密码一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      // 获取当前页面名称
      nowRouteName: '',
      nowRouteIcon: '',
      userInfo: '',

      //修改密码弹框
      passwordDialogVisible: false,
      submitting: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      //积分配置弹框
      pointsDialogVisible: false,
      pointsForm: {
        pointSetting: ''
      },
      pointsRules: {
        pointSetting: [
          { required: true, message: '请输入积分兑换比例', trigger: 'blur' },
        ]
      }
    };
  
  },

  mounted() {
    // 设置标题
    this.setNowRouteName(this.$route)
    // 获取用户信息
    this.getUserInfo()
  },

  methods: {
    // 获取用户信息
    getUserInfo() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    },
    // 获取当前页面标题
    setNowRouteName(route) {
      this.nowRouteName = route.meta.title
      this.nowRouteIcon = route.meta.icon
    },
    // 关闭标签事件
    goBack() {
      // 判断路由是否能返回
      if (window.history.length <= 2) {
        this.goHome()
      } else {
        this.$router.go(-1)
      }
    },
    // 回到首页
    goHome() {
      this.$router.replace('/home')
    },
    // 点击下拉菜单回调
    clickmenu(e) {
      if (e === 'outlogin') {
        this.outLogin()
      }
    },
    //下拉抽屉
    handleCommand(command) {
      switch (command) {
        case 'password':
          this.handleChangePassword()
          break
        case 'points':
          this.handlePointsConfig()
          break
        case 'logout':
          this.handleLogout()
          break
      }
    },
    handleChangePassword() {
      this.passwordDialogVisible = true;
        // 重置表单
        this.$nextTick(() => {
          this.$refs.passwordForm && this.$refs.passwordForm.resetFields();
        });
      },
  
    //提交修改密码表单
    submitPasswordForm() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.changePassword();
        } else {
          return false;
        }
      });
    },
    async changePassword() {
      this.submitting = true;
      try {
        const passwordForm = {
          newPwd: this.passwordForm.newPassword,
      }
        // 调用修改密码API
        const res = await getChangePassword(passwordForm)
        if(res.code == 200){
          this.$message.success('密码修改成功');
          this.passwordDialogVisible = false;
          // 修改密码后强制重新登录
          this.$router.push('/login');
        }

      } catch (error) {
        let errorMessage = '密码修改失败';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        this.$message.error(errorMessage);
      } finally {
        this.submitting = false;
      }
    },
  
    //积分配置
    async handlePointsConfig() {
      this.pointsDialogVisible = true;
      const res = await getPointSetting();
      console.info(res)
      if(res.code == 200){
        this.pointsForm.pointSetting = res.data
      }
        // // 重置表单
        // this.$nextTick(() => {
        //   this.$refs.pointsForm && this.$refs.pointsForm.resetFields();
        // });
    },

     //提交积分配置表单
     submitPointsForm() {
      this.$refs.pointsForm.validate(async (valid) => {
        if (valid) {
          const pointsForm = {
            pointSetting : this.pointsForm.pointSetting
          }
          const res = await updatePointSetting(pointsForm)
          if(res.code == 200){
            this.$message.success('积分配置成功');
            this.pointsDialogVisible = false;
          }
        } else {
          return false;
        }
      });
    },
    //退出登录
    handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用退出登录API
        // 回到首登录页
        this.$router.replace('/login')
      }).catch(() => {
        this.$message.info('已取消退出')        
      })
    },
 
  },

  watch: {
    $route: function (newRoute) {
      this.setNowRouteName(newRoute)
    },
  },

 
}  
</script>

<style lang="less" scoped>
// 左侧操作图标
.left-caozuoicon {
  display: flex;
  align-items: center;
  gap: 30px;
  padding-left: 20px;
  box-sizing: border-box;
  .pgeas-tab {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
}
// 右侧用户头像
.user-logininfo {
  display: flex;
  align-items: center;
  position: fixed;
  right: 16px;
  gap: 10px;
  cursor: pointer;

  .image {
    width: 30px;
    height: 30px;
    border-radius: 15px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.right-userName {
  display: flex;
  align-items: center;
  gap: 10px;
}

.el-dropdown-menu {
  width: 120px;
  padding: 0;
}
.el-dropdown-menu__item {
  display: flex;
  align-items: center;
}

.el-dropdown-menu__item i {
  margin-right: 8px;
  padding-left: 30px;
  font-size: 16px;
}

.el-dropdown-menu__item--divided {
  border-top: 1px solid #ebeef5;
}

.tips{
  margin-left: 34px;
  font-size: 12px;
  color: rgb(145, 145, 145);
}

</style>